"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
function DecisionMenu(_a) {
    var data = _a.data, onChange = _a.onChange, componentClass = _a.componentClass, dropDownTitle = _a.dropDownTitle, dropDirectionClass = _a.dropDirectionClass, dataCy = _a.dataCy;
    var _b = __read((0, react_1.useState)(''), 2), searchText = _b[0], setSearchText = _b[1];
    var _c = __read((0, react_1.useState)(null), 2), selectedIndex = _c[0], setSelectedIndex = _c[1];
    var dropdownContainerRef = react_1.default.useRef(null);
    var filteredData = data.filter(function (item) { return item.name.toLowerCase().includes(searchText.toLowerCase()); });
    (0, react_1.useEffect)(function () {
        var handleKeyDown = function (event) {
            var keys = ['ArrowDown', 'ArrowUp', 'Enter', 'Escape'];
            if (!keys.includes(event.key))
                return;
            event.preventDefault();
            switch (event.key) {
                case 'ArrowDown':
                    setSelectedIndex(function (prev) { return (prev === null ? 0 : Math.min(prev + 1, filteredData.length - 1)); });
                    break;
                case 'ArrowUp':
                    setSelectedIndex(function (prev) { return (prev === null ? 0 : Math.max(prev - 1, 0)); });
                    break;
                case 'Enter':
                    if (selectedIndex !== null) {
                        onChange(filteredData[selectedIndex]);
                    }
                    break;
                case 'Escape':
                    setSearchText('');
                    setSelectedIndex(null);
                    break;
                default:
                    break;
            }
        };
        // remove keyboard focus on mouse move
        var handleMouseMove = function () {
            setSelectedIndex(null);
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('mousemove', handleMouseMove);
        };
    }, [selectedIndex, data, onChange, setSearchText]);
    (0, react_1.useEffect)(function () {
        if (selectedIndex !== null && dropdownContainerRef.current) {
            var selectedItem = dropdownContainerRef.current.children[selectedIndex];
            if (selectedItem) {
                selectedItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        }
    }, [selectedIndex]);
    return (react_1.default.createElement("ul", { className: "dropdown-menu ".concat(dropDirectionClass, " ").concat(componentClass), role: "menu" },
        react_1.default.createElement("p", { className: "drop-down-menu-title" }, dropDownTitle),
        react_1.default.createElement("div", { className: (0, clsx_1.default)("eva-dropdown-container", data.length === 0 && 'empty-list'), ref: dropdownContainerRef }, filteredData.map(function (item, index) { return (react_1.default.createElement("li", { key: index, 
            // for some reason onClick is not working
            onMouseDown: function () {
                onChange(item);
            }, "data-cy": "".concat(dataCy, "-").concat(item.name), title: item.name, className: (0, clsx_1.default)(selectedIndex === index && 'focused') },
            react_1.default.createElement("a", null, item.name))); })),
        react_1.default.createElement("div", { className: "dropdown-menu-input-container" },
            react_1.default.createElement("span", { className: "dropdown-menu-input-container-icon implioicons-search" }),
            react_1.default.createElement("input", { className: "search-input", autoFocus: true, value: searchText, onChange: function (e) { return setSearchText(e.target.value); } })),
        react_1.default.createElement("div", { className: "eva-dropdown-arrow" }),
        react_1.default.createElement("div", { className: "eva-dropdown-arrow-cover" }),
        react_1.default.createElement("div", { className: "eva-dropdown-hover-area" })));
}
exports.default = DecisionMenu;
